import ArticlesTemplate from "components/templates/ArticlesTemplate/ArticlesTemplate";

const ArticlesPage = () => {
  return <ArticlesTemplate />;
};

export default ArticlesPage;
